const state = {
    isIntro : null,
    isExpire : null,
    isPrivacy : null,
    isInternalUser: null,
    isExternalUser : null
};
const actions = {

};
const mutations = {
    setIntroInfo(state, payload) {
        if (payload !== null) {
            if (payload.isIntro !== null) {
                state.isIntro = payload.isIntro;
            }
            if (payload.isExpire !== null) {
                state.isExpire = payload.isExpire;
            }
            if (payload.isPrivacy !== null) {
                state.isPrivacy = payload.isPrivacy;
            }
            if (payload.isInternalUser !== null) {
                state.isInternalUser = payload.isInternalUser;
            }
            if (payload.isExternalUser !== null) {
                state.isExternalUser = payload.isExternalUser;
            }
        }
    }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/common/introInfo.js